import { Injectable } from '@angular/core';
import { AnalyticsService } from '@epicuro-next/platform/monitoring';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { trackEvent } from '../actions';

@Injectable()
export class EventTrackerEffects {
  constructor(private actions$: Actions, private analytics: AnalyticsService) {}

  public trackEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(trackEvent),
        tap(({ event }) => {
          const { name, properties } = event;
          this.analytics.trackEvent({
            name,
            properties: {
              ...properties,
              type: name,
            },
          });
        }),
      ),
    { dispatch: false },
  );
}
